<app-modal-dialog title="Your AS2 Information" (dismiss)="cancel()">
    <main>
        <form #form="ngForm">
            <app-layout-row>                
                <app-layout-column [width]="12">

                    <app-layout-row margin="0rem">
                        <app-layout-column [width]="12">
                            <app-singleselectbox [ngModel]="selectedConnection()" valueExpr="value" displayExpr="name" [name]="'as2Connection'" [caption]="'AS2 Type'" [dataSource]="as2Connections()" required (ngModelChange)="connectionChanged($event)"></app-singleselectbox>
                        </app-layout-column>
                    </app-layout-row>

                    <app-layout-row margin="0rem">
                        <app-layout-column [width]="12">
                            <app-singleselectbox [ngModel]="selectedAs2Id()" valueExpr="value" displayExpr="name" [name]="'as2Id'" [caption]="'AS2 ID'" [dataSource]="as2Ids()" required (ngModelChange)="idChanged($event)"></app-singleselectbox>
                        </app-layout-column>
                    </app-layout-row>

                    <app-layout-row margin="0rem">
                        <app-layout-column [width]="12">
                            <p class="summary-title">Summary:</p>
                            <div class="property-grid">
                                <p class="property-name">Host name: </p>
                                <p class="property-value">{{hostname()}}</p>
                                <p class="property-name">AS2 ID: </p>
                                <p class="property-value">{{selectedAs2Id()}}</p>
                                <p class="property-name">Public certificate: </p>
                                <p class="property-value">{{as2PublicCert() ? as2PublicCert().Name + ' (' + as2PublicCert().SerialNumber + ')' : ''}}</p>
                            </div>
                        </app-layout-column>
                    </app-layout-row>
                </app-layout-column>
            </app-layout-row>            
        </form>
    </main>

    <footer>
        <div class="button-container">
            <app-button [disabled]="!form.valid || missingValues()" primary (buttonClick)="accept()">Ok</app-button>
            <app-button secondary (buttonClick)="cancel()">Cancel</app-button>
        </div>
    </footer>
</app-modal-dialog>